<template>
  <div class="text-center mt-10 empty-state-root">
    <div class="empty-state-img">
      <img src="/img/empty_page.2ea2b496.svg" alt="empty state">
    </div>

    <div class="empty-state-desc">
      <p> {{ description }} </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['description']
}
</script>

<style lang="scss" scoped>

.empty-state-root {
  margin-top: 32px;

  .empty-state-title {
    h4 {
      color: #2c2c2c;
      font-weight: 500;
      font-size: 24px;
    }
  }

  .empty-state-img {
    text-align: center;
    margin-top: 80px;

    img {
      width: 378px;
    }
  }

  .empty-state-desc {
    text-align: center;

    p {
      color: rgba(0, 0, 0, 0.56);
      font-size: 18px;
      margin-bottom: 40px;
    }
  }

  @media (max-width: 768px) {
    .empty-state-img img {
      width: 250px;
    }
  }
}
</style>
